import React from 'react';
import { Button } from './ui/button';
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from './ui/alert-dialog';

export const DeleteRequestConfirm = ({ onCancel, onConfirm }) => (
  <AlertDialog open onOpenChange={(v) => { if (!v) onCancel(); }}>
    <AlertDialogContent data-testid="delete-request-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete this maintenance request?</AlertDialogTitle>
        <AlertDialogDescription>
          The request is removed permanently. Any work order, maintenance log or follow-up created from it is kept.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button variant="outline" onClick={onCancel} data-testid="cancel-delete-request-btn">Cancel</Button>
        <Button className="bg-red-600 hover:bg-red-700 text-white" onClick={onConfirm} data-testid="confirm-delete-request-btn">
          Delete request
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
